import { t } from 'i18next';
import { IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { setPopperVisiblity } from '../../model/main';
import * as Styled from './styled';

export const PopperHeader = () => (
  <Styled.Header>
    <Typography variant="subtitle2">{t('navMenu.dispatch.calls')}</Typography>

    <IconButton onClick={() => setPopperVisiblity(false)} size="small">
      <CloseIcon />
    </IconButton>
  </Styled.Header>
);
